module.exports = __webpack_public_path__ + "static/media/wd5.0d4c3f56.jpeg";